<!--<zxing-scanner (scanSuccess)="scanSuccessHandler($event)"
></zxing-scanner>
-->


<div class="row">
  <div class="col-12 image">
    <img src="../../../../assets/resources/myvivienda.svg">
  </div>
  <div class="col-6 col-lg-6">
    <zxing-scanner  #scanner (scanSuccess)="scanSuccessHandler($event)">
    </zxing-scanner>
  </div>
</div>
